import React from "react"

export default class ExportComponent extends React.Component {
	
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	render() {
		return (
			<div className="ExportComponent">
				{this.renderPDF()}
				<hr />
				{this.renderPPT()}
			</div>
		);	
	}

	renderPDF() {
		if (this.props.formats && this.props.formats.indexOf('PDF') != -1) {
			return (
				<div className="format-pdf">
					<ul>
						<li><a href={this.props.export_article_path + '.pdf'}>Download article (images and text) as PDF document</a></li>
						<li><a href={this.props.export_article_images_only_path + '.pdf'}>Download article (images only) as PDF document</a></li>
						<li><a href={this.props.export_course_path + '.pdf'}>Download course (images and text) as PDF document</a></li>
						<li><a href={this.props.export_course_images_only_path + '.pdf'}>{I18n.t('download_course')} (images only) as PDF document</a></li>
					</ul>
				</div>
			);
		}
	}

	renderPPT() {
		if (this.props.formats && this.props.formats.indexOf('PPT') != -1) {
			return (
				<div className="format-ppt">
					<ul>
						<li><a href={this.props.export_article_images_only_path + '.ppt'}>Download article (images only) as Powerpoint file</a></li>
						<li><a href={this.props.export_course_images_only_path + '.ppt'}>{I18n.t('download_course')} (images only) as Powerpoint file</a></li>
					</ul>
				</div>
			);
		}
	}



	/**
	* Change handlers
	*/

	onClick(e) {
		e.preventDefault();
		e.stopPropagation();
	}

}